<template>
    <div id="contenedor-principal-comunicados">
        <CCargandoInformacion v-if="cargandoInformacion" :mostrarError="ocurrioError"></CCargandoInformacion>
        <div v-if="!cargandoInformacion">
            <div v-if="this.campoRequeridoEsValido(datosArea)" id="titulo-area">
                <h1>{{ datosArea.titulo }}</h1>
                <h3>{{ datosArea.subtitulo }}</h3>
                <div class="hr-titulo"/>
            </div>
            <CSeccion v-for="(seccion) in secciones" :key="'seccion-' + seccion.SeccionId" 
                class="espacio-entre-secciones"
                :informacion="{ idElemento: seccion.SeccionId, nombre: seccion.Nombre }"
                :formatosDeSeccion="[{ tipoDeFormato: seccion.FormatoId, contenidos: seccion.Contenidos }]"
                :opciones="{ tiposDocumentoArea: tiposDocumentosArea}"></CSeccion>
        </div>
    </div>
</template>
<script>
import CSeccion from "@/components/Intranet/Comun/CSeccion.vue";
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import CCargandoInformacion from "@/components/Intranet/Comun/CCargandoInformacion";
import axios from 'axios'
import router from '@/router/index'

export default {
    components: {
        CSeccion: CSeccion,
        CCargandoInformacion
    },
    beforeRouteEnter (to, from, next) {
        const VISTA_RAIZ = 'Inicio';
        next(async (instanciaVue) => {
            instanciaVue.cargandoInformacion = true;
            const PAGINA_HABILITADA = await Promise.resolve(instanciaVue.usuarioTieneLaPaginaHabilitada({ ruta: to.path }));
            if(!PAGINA_HABILITADA) {
                router.push({ name: VISTA_RAIZ});
                instanciaVue.cargandoInformacion = false;
                comun.mensajeDeAlerta('No tienes acceso a la pagina solicitada', null, null);
            }
        });
    },
    data() {
        return {
            secciones: [],
            datosArea: {  titulo: 'Noticias', subtitulo: '' },
            tiposDocumentosArea: [],
            cargandoInformacion: true,
            ocurrioError: false
        }
    },
    methods: {
        usuarioTieneLaPaginaHabilitada: async function({ ruta }) {
            let habilitada = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.VerificarSiTieneHabilitadaPagina;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDePagina: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: ruta })
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, TieneHabilitadaLaPagina } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    habilitada = TieneHabilitadaLaPagina
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return habilitada;
        },
        // SECCION PARA FUNCIONES
        iniciarProcesoCargaDeInformacion: async function() { debugger
            try {
                this.cargandoInformacion = true;
                const CARGO_CONTENIDOS_SIN_ERROR = await Promise.resolve(this.obtenerPaginaConSeccionesYContenidosBD());
                this.cargandoInformacion = !(CARGO_CONTENIDOS_SIN_ERROR);
                this.ocurrioError = this.cargandoInformacion;
                console.log('formatosCPRincipal::',this.secciones);
                $('html, body').animate({ scrollTop:0 }, 'slow');
            }
            catch(excepcion) {
                console.log(excepcion);
            }
        },
        obtenerPrefijoBaseDeLaRuta: function({ rutaDeLaPaginaDeIntranet }) { 
            let rutaBase = rutaDeLaPaginaDeIntranet;
            let elementosRuta = rutaDeLaPaginaDeIntranet.split('/');
            if(this.campoRequeridoEsValido(elementosRuta)) {
                // 1 parametros a eliminar para obtener la ruta base
                elementosRuta.pop();
                rutaBase = elementosRuta.join('/');
            }
            return rutaBase;
        },
        obtenerPaginaConSeccionesYContenidosBD: async function() {
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.ObtenerContenidosDeIntranetAdministracion;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDeLaPaginaDeIntranet: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: this.$route.fullPath }), 
                    PorAreaDeUsuario: false,
                    EsPrueba: false 
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, PaginaDeIntranet } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    console.log('objPagina::',PaginaDeIntranet);
                    await Promise.resolve(this.convertirContenidosAObjetosDeFormatos({ pagina: PaginaDeIntranet }));
                    procesoSinError = true;
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return procesoSinError;
        },
        convertirContenidosAObjetosDeFormatos: async function({ pagina }) {
            if(this.campoRequeridoEsValido(pagina)) {
                const { SeccionesDeIntranet } = pagina;
                if(this.campoRequeridoEsValido(SeccionesDeIntranet)) {
                    this.secciones = SeccionesDeIntranet.map(sBD => {
                        let seccionObj = {};
                        seccionObj.SeccionId = sBD.SeccionDeIntranetId;
                        seccionObj.Nombre = sBD.Nombre;
                        seccionObj.FormatoId = 43;
                        let contenidosDeSeccionObj = sBD.Contenidos.map(cBD => {
                            let contenidoObj = {};
                            contenidoObj.Folio = cBD.ContenidoDeIntreanetId;
                            contenidoObj.Titulo = `<strong style="color: #be9a5e;">${ cBD.Comunicado.Titulo }</strong>`;
                            contenidoObj.RutaDeAcceso = cBD.Comunicado.RutaDeImagen;
                            contenidoObj.Fecha = moment(cBD.Comunicado.Fecha).format('YYYY-MM-DD');
                            contenidoObj.RutaDeArchivo = cBD.ArchivosDeContenidoIntranet[0].Ruta;
                            contenidoObj.DescripcionCompleta = `<strong>${ cBD.Comunicado.SubTitulo }</strong> - ${ cBD.TextoDelContenido }`;
                            contenidoObj.Descripcion = this.acortarTextoDeNoticia({ texto: contenidoObj.DescripcionCompleta, numeroDeCaracteres: 150 });
                            return contenidoObj;
                        });
                        seccionObj.Contenidos = contenidosDeSeccionObj;
                        return seccionObj;
                    });
                   /*  this.secciones.push(seccionConFormato); */
                }
            }
        },
        acortarTextoDeNoticia: function({ texto, numeroDeCaracteres }) {
            let textoValido = '';
            if(this.campoRequeridoEsValido(texto)) {
                textoValido = (texto.length > numeroDeCaracteres) ? texto.substring(0,numeroDeCaracteres) : texto; 
                textoValido += ' ...';
            } 
            return textoValido;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    async created() { 
        await Promise.resolve(this.iniciarProcesoCargaDeInformacion());
        // buscar en bd las secciones del area
        /* this.secciones = [
            { 
                SeccionId: 13,
                Nombre: 'Noticias',
                FormatoId: 43,
                Contenidos: [
                    { Folio: 1, Fecha: '01/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 2, Fecha: '02/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 3, Fecha: '03/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 4, Fecha: '04/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 5, Fecha: '05/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 6, Fecha: '06/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 7, Fecha: '07/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 8, Fecha: '08/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 9, Fecha: '09/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 10, Fecha: '10/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 11, Fecha: '11/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 12, Fecha: '12/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 13, Fecha: '13/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' },
                    { Folio: 14, Fecha: '14/01/2021', Titulo: 'Noticia 1', Descripcion: 'Acuerdo general 1' }
                ]
            }
        ]; */
    },
    watch: {
        '$store.state.Login_PermisosDelSistema': function() {
            console.log('permisos::',this.$store.state.Login_PermisosDelSistema);
        }
    }
}
</script>
<style scoped>

.espacio-entre-secciones {
    margin-top: 3vmin;
}

#contenedor-principal-comunicados {
    /* padding: 7vmin 12vmin 0vmin 12vmin; */
    padding: 4em 6em 4em 6em;
}

#titulo-area h1 {
    font-size: 5vmin;
    font-weight: bold;
    color: #0f0f0f;
    margin-bottom: 0;
}

#titulo-area {
    margin-bottom: 3em;
}

#titulo-area h3 {
    font-size: 2.5vmin;
    color: #8d8d8d;
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#be9a5e;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Areas/CComunicadosLista.vue